var render = function () {
  var _vm$collection$name;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CollectionList",
      "extra-items": _vm.isEditing ? [{
        text: (_vm$collection$name = _vm.collection.name) !== null && _vm$collection$name !== void 0 ? _vm$collection$name : '',
        to: 'CollectionItemList',
        params: _vm.$route.params.id
      }, '編輯資料集'] : ['新增資料集']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.step == '',
      done: _vm.collection.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("基本設定")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: {
      active: _vm.step == '#fields',
      done: _vm.collection.config.fields && _vm.collection.config.fields.length > 0,
      disabled: !_vm.collection.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#fields');
      }
    }
  }, [_c('a', [_vm._v("欄位設定")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: {
      active: _vm.step == '#collection-info',
      disabled: !_vm.collection.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#collection-info');
      }
    }
  }, [_c('a', [_vm._v("欄位資訊")])]), _c('li', {
    class: {
      active: _vm.step == '#advanced-setting',
      disabled: !_vm.collection.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#advanced-setting');
      }
    }
  }, [_c('a', [_vm._v("進階設定")])])])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isEditing ? '編輯資料集' : '新增資料集'))]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*資料集標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.collection.name.$error ? false : null
    },
    model: {
      value: _vm.collection.name,
      callback: function callback($$v) {
        _vm.$set(_vm.collection, "name", $$v);
      },
      expression: "collection.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.collection.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*資料集代碼"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.collection.code.$error ? false : null
    },
    model: {
      value: _vm.collection.code,
      callback: function callback($$v) {
        _vm.$set(_vm.collection, "code", $$v);
      },
      expression: "collection.code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.collection.code.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "資料集描述"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.collection.description,
      callback: function callback($$v) {
        _vm.$set(_vm.collection, "description", $$v);
      },
      expression: "collection.description"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#fields' ? _c('section', [_c('div', [_vm.collection.id ? _c('DynamicFormEditor', {
    attrs: {
      "editor-title": "欄位設定",
      "input-subjects": _vm.collection.config.fields,
      "form-type": 'collection'
    },
    on: {
      "output": _vm.saveFields,
      "cancel": function cancel($event) {
        return _vm.$router.push({
          name: 'CollectionList'
        });
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm.step == '#advanced-setting' ? _c('section', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("進階設定")]), _c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟動分店關聯"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.collection.config.related_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.collection.config, "related_branch", $$v);
      },
      expression: "collection.config.related_branch"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟動員工關聯"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.collection.config.related_staff,
      callback: function callback($$v) {
        _vm.$set(_vm.collection.config, "related_staff", $$v);
      },
      expression: "collection.config.related_staff"
    }
  }), _c('JsonEditor', {
    ref: "staffRoleFilter",
    attrs: {
      "lines": 5
    },
    model: {
      value: _vm.collection.config.staff_role_filter,
      callback: function callback($$v) {
        _vm.$set(_vm.collection.config, "staff_role_filter", $$v);
      },
      expression: "collection.config.staff_role_filter"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.collection.config.staff_role_filter.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors('collection.config.staff_role_filter')) + " ")])], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)]) : _vm._e(), _vm.step == '#collection-info' ? _c('section', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("欄位資訊")]), _vm.collection.id ? _c('DynamicFormReadOnly', {
    attrs: {
      "input-subjects": _vm.collection.config.fields
    },
    on: {
      "cancel": function cancel($event) {
        return _vm.$router.push({
          name: 'BookingPresetList'
        });
      }
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }